import { Checkbox, CheckboxProps } from "antd";

export const DefaultCheckbox: React.FC<CheckboxProps> = (props) => <Checkbox {...props}>{props.children}</Checkbox>;
